module.exports = __webpack_public_path__ + "img/1.ed68179f.png";